import React, { useState } from "react";
import { useSelector } from "react-redux";
import CreateInventory from "./createInventory";
import InventoryList from "./inventoryList";
import { toast } from "../../../components/AppToast";
import { saveInventoryAPI,updateInventoryAPI } from "../../../services/inventory/inventory";


export default function InventoryManagement() {

  const [isCreating, setIsCreating] = useState(false);
  const [activeRecord, setActiveRecord] = useState(null);
  const [listVersion, setListVersion] = useState(0);
 const { userDetail } = useSelector(state => state.login);
  const onlyFormVisible = isCreating || !!activeRecord;

  const closeForm = () => {
    setIsCreating(false);
    setActiveRecord(null);
  };

  const submitForm = async (formData, id) => {
    try {

      if (id) {
        const res = await updateInventoryAPI(formData, id);
        formData.updatedBy = userDetail?.email;

        if (res.success) {
          toast.success("Inventory updated successfully");
          closeForm();
          setListVersion(v => v + 1);
        } else {
          toast.error("Inventory update failed");
        }

      } else {

        const res = await saveInventoryAPI(formData);

        if (res.success) {
          toast.success("Inventory created successfully");
          closeForm();
          setListVersion(v => v + 1);
        } else {
          toast.error("Inventory creation failed");
        }

      }

    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="card shadow-lg main-card">

      {/* HEADER */}
      <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
        <h4 className="mb-0 h6 fw-semibold">
          {!onlyFormVisible
            ? "Inventory Management"
            : isCreating
              ? "Create Inventory"
              : activeRecord?.mode === "edit"
                ? "Edit Inventory"
                : "View Inventory"}
        </h4>
      </div>


      {/* BREADCRUMB */}
      {onlyFormVisible && (
        <nav
          aria-label="breadcrumb"
          className="px-3 py-2 border-bottom bg-light"
        >
          <ol
            className="breadcrumb mb-0 align-items-center"
            style={{ ["--bs-breadcrumb-divider"]: "'/'" }}
          >
            <li className="breadcrumb-item">
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={closeForm}
              >
                Inventory Management
              </button>
            </li>

            <li
              className="breadcrumb-item active fw-semibold text-primary"
              aria-current="page"
            >
              {isCreating
                ? "Create Inventory Mgt"
                : activeRecord?.mode === "edit"
                  ? "Edit Inventory Mgt"
                  : "View Inventory Mgt"}
            </li>
          </ol>
        </nav>
      )}


      {/* BODY */}
      <div className="card-body">

        {!onlyFormVisible ? (

          <InventoryList
            refreshKey={listVersion}
            onCreateClick={() => setIsCreating(true)}
            onView={(row) => setActiveRecord({ mode: "view", data: row })}
            onEdit={(row) => setActiveRecord({ mode: "edit", data: row })}
          />

        ) : (

          <CreateInventory
            initialValues={activeRecord?.data || {}}
            onCancel={closeForm}
            onSubmit={submitForm}
            viewOnly={activeRecord?.mode === "view"}
            isEdit={activeRecord?.mode === "edit"}
          />

        )}

      </div>
    </div>
  );
}